


export class BrowserAppEvaluationToolInfo {

  public version = '2024.5.7.1';

  constructor() {
  }

}
